export default __webpack_public_path__ + "static/EFNWidok-26bbf75c300be3a6d5b0d06ae654efab.ttf";